import {
  DeleteBookmarkDocument,
  GetBookmarkDocument,
  ListBookmarkItemsDocument,
  ListMyBookmarkItemsDocument,
  ListUserBookmarksDocument,
  UpdateBookmarkItemDocument,
  UpsertBookmarkDocument,
} from './generated/graphql'
import {
  createFetchQueryHelper,
  createMutationHelper,
  createQueryHook,
  modifyQueryHook,
} from './utils'

export const useListMyBookmarkItems = modifyQueryHook(
  createQueryHook(ListMyBookmarkItemsDocument),
  {
    reduce: r => r?.me?.defaultBookmark?.items,
  },
)
export const fetchListMyBookmarkItems = createFetchQueryHelper(
  ListMyBookmarkItemsDocument,
)
export const [useUpdateBookmarkItem, executeUpdateBookmarkItem] =
  createMutationHelper(UpdateBookmarkItemDocument)

export const useListUserBookmarks = modifyQueryHook(
  createQueryHook(ListUserBookmarksDocument),
  {
    reduce: r => r?.user?.bookmarks,
  },
)
export const fetchListUserBookmarks = createFetchQueryHelper(
  ListUserBookmarksDocument,
)

export const useListBookmarkItems = modifyQueryHook(
  createQueryHook(ListBookmarkItemsDocument),
  {
    reduce: r => r?.bookmark?.items,
  },
)

export const useGetBookmark = modifyQueryHook(
  createQueryHook(GetBookmarkDocument),
  {
    transform: (id: string) => ({ id }),
    reduce: r => r?.bookmark,
  },
)
export const fetchGetBookmark = createFetchQueryHelper(GetBookmarkDocument)

export const [useUpsertBookmark, executeUpsertBookmark] = createMutationHelper(
  UpsertBookmarkDocument,
)
export const [useDeleteBookmark, executeDeleteBookmark] = createMutationHelper(
  DeleteBookmarkDocument,
)
